// PEAK4 Brand Colours — 2026 Branding Guidelines
// Source: dev-docs/PEAK4 Branding Guidelines 2026.pdf

// Base palette / primary colours
export const CHARCOAL = "#1A1A1D";
export const GRAPHITE_GREY = "#2E2E33";
export const QUARTZ_WHITE = "#F5F7FA";
export const PEAK4_BLUE = "#47A8AF";
export const SUMMIT_GREEN = "#43995B";

// Secondary colours
export const PERFORM_ORANGE = "#E67E22";
export const RECOVER_PINK = "#E46E80";
export const FUEL_INDIGO = "#4951B6";
export const FOCUS_LILAC = "#A77DD2";

export const brandColors = {
  charcoal: CHARCOAL,
  graphiteGrey: GRAPHITE_GREY,
  quartzWhite: QUARTZ_WHITE,
  peak4Blue: PEAK4_BLUE,
  summitGreen: SUMMIT_GREEN,
  performOrange: PERFORM_ORANGE,
  recoverPink: RECOVER_PINK,
  fuelIndigo: FUEL_INDIGO,
  focusLilac: FOCUS_LILAC,
} as const;
